import fs from 'node:fs';
import path from 'node:path';
import { removeSymbolIndexForFile, updateSymbolIndexForFile } from '../../code-nav/index.js';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import {
  CliSqliteInterrupted,
  CodeNavCacheUnavailableError,
} from '../../sqlite/code-nav-cache/database.js';

export async function applyIncrementalSymbolIndexUpdates(
  resolved: string,
  relPaths: Iterable<string>,
): Promise<void> {
  for (const rel of relPaths) {
    const absPath = path.join(resolved, rel);
    try {
      const stat = await fs.promises.stat(absPath);
      if (stat.isFile()) {
        await updateSymbolIndexForFile(resolved, absPath);
      } else {
        await removeSymbolIndexForFile(resolved, absPath);
      }
    } catch (err) {
      if ((err as NodeJS.ErrnoException).code === 'ENOENT') {
        await removeSymbolIndexForFile(resolved, absPath);
      } else if (
        err instanceof CliSqliteInterrupted ||
        err instanceof CodeNavCacheUnavailableError ||
        isCliImmediateShutdownRequested()
      ) {
        /* expected during shutdown or when indexing is disabled */
      } else {
        console.error(`[code-nav] Incremental update failed for ${rel}:`, err);
      }
    }
    await yieldToEventLoop();
  }
}
